// Interfaces
export interface RewardConfig {
    received: number,
    reward: string,
    valid_count: string
}

export interface InfoConfig {
    equipment_limit: string,
    ip_limit: string,
    recharge_require: string,
    turnover_require: string,
    turnover_require_times: string,
    valid_user_count: number,
    link: string,
    reward_conf: RewardConfig[]
}

export interface TreasureData {
    descriptionHtml : any[]
    activityConfig : InfoConfig
    bannerIcon : string
}

// Constant
export const MEDIA_LIST = [
    {
        name: 'socialMedia.facebook',
        icon: require('@/assets/bauDo/fb_icon.png')
    },
    {
        name: 'socialMedia.whatsapp',
        icon: require('@/assets/bauDo/whatsapp_icon.png')
    },
    {
        name: 'socialMedia.telegram',
        icon: require('@/assets/bauDo/telegram_icon.png')
    },
    {
        name: 'socialMedia.instagram',
        icon: require('@/assets/bauDo/instagram_icon.png')
    },
    {
        name: 'socialMedia.twitter',
        icon: require('@/assets/bauDo/twitter_icon.png')
    },
    {
        name: 'socialMedia.kwai',
        icon: require('@/assets/bauDo/kwai_icon.png')
    },
]
// Functions

export const copyValue = async (value: string, onSuccess?: () => void) => {
  if (!value) return
  try {
    await navigator.clipboard.writeText(value)
    console.log('Copied to clipboard:', value)
    onSuccess && onSuccess() // call the callback
  } catch (err) {
    console.error('Failed to copy: ', err)
  }
}